<div class="container-fluid sell_dash">
	<div class="wrapper">
	  <div class="row">
		<app-sidemenu></app-sidemenu>
		 <section class="right">
		   <app-sellheader></app-sellheader>
			 <div class="right-middle row justify-content-center">
			   <div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12">
				<div class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
				   <!-- begin:: Content -->
				   <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
					   <!--Begin::App-->
					   <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">
						   <!--Begin:: App Aside Mobile Toggle-->
						   <button class="kt-app__aside-close" id="kt_user_profile_aside_close"> <i class="la la-close"></i> </button>
							   <!--End:: App Aside Mobile Toggle-->
							   <!--Begin:: App Aside-->
							   <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">
								<!--begin:: Widgets/Applications/User/Profile1-->
								 <div class="kt-portlet kt-portlet--height-fluid-">
								   <div class="kt-portlet__body kt-portlet__body--fit-y">
									 <!--begin::Widget -->
									 <div class="kt-widget kt-widget--user-profile-1 pt-5">
									   <div class="kt-widget__head mt-2">
										   <div class="kt-widget__media"> <img src="./assets/image/user.png" alt="image"> </div>
										   <div class="kt-widget__content">
											   <div class="kt-widget__section"> 
												   <a href="#" class="kt-widget__username">
													 Gaurav Gupta
													 <i class="flaticon2-correct kt-font-success"></i>
												   </a> 
												   <span class="kt-widget__subtitle">
												   Head of Data Science
												   </span> 
											   </div>
											   <div class="kt-widget__action">
												   <button type="button" class="btn btn-primary">Active</button>
											  </div>
										   </div>
									   </div>
									   <div class="kt-widget__body">
										   <div class="kt-widget__content">
											   <div class="kt-widget__info"> <span class="kt-widget__label">Client Id:</span> <a href="#" class="kt-widget__data">12345</a> </div>
											   <div class="kt-widget__info"> <span class="kt-widget__label">Email:</span> <a href="#" class="kt-widget__data">abc@gmail.com</a> </div>
											   <div class="kt-widget__info"> <span class="kt-widget__label">Phone:</span> <a href="#" class="kt-widget__data">(+91)356432446</a> </div>
											   <div class="kt-widget__info"> <span class="kt-widget__label">Location:</span> <span class="kt-widget__data">New Delhi</span> </div>
										   </div>
										   <div class="kt-widget__items">
											   <ul class="nav nav-tabs nav-tabs-space-xl nav-tabs-line nav-tabs-bold" role="tablist">
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_5" role="tab" class="nav-link kt-widget__item"> <span class="kt-widget__section">
												   <span class="kt-widget__icon">
													   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															   <polygon points="0 0 24 0 24 24 0 24"></polygon>
															   <path d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z" fill="#000000" fill-rule="nonzero"></path>
															   <path d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z" fill="#000000" opacity="0.3"></path>
														   </g>
													   </svg> </span> <span>
													   Profile Overview
												   </span> </span>
													   </a>
												   </li>
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_1" role="tab" class="nav-link kt-widget__item active"> <span class="kt-widget__section">
													   <span class="kt-widget__icon">	 
														 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															   <polygon points="0 0 24 0 24 24 0 24" />
															   <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
															   <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
														   </g>
													   </svg>
													 </span> <span>Personal Information</span> </span>
													   </a>
												   </li>
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_2" role="tab" class="nav-link kt-widget__item"> <span class="kt-widget__section">
													<span class="kt-widget__icon">	 
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															   <rect x="0" y="0" width="24" height="24"/>
															   <path d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
															   <rect fill="#000000" opacity="0.3" transform="translate(12.000000, 8.000000) scale(1, -1) rotate(-180.000000) translate(-12.000000, -8.000000) " x="11" y="2" width="2" height="12" rx="1"/>
															   <path d="M12,2.58578644 L14.2928932,0.292893219 C14.6834175,-0.0976310729 15.3165825,-0.0976310729 15.7071068,0.292893219 C16.0976311,0.683417511 16.0976311,1.31658249 15.7071068,1.70710678 L12.7071068,4.70710678 C12.3165825,5.09763107 11.6834175,5.09763107 11.2928932,4.70710678 L8.29289322,1.70710678 C7.90236893,1.31658249 7.90236893,0.683417511 8.29289322,0.292893219 C8.68341751,-0.0976310729 9.31658249,-0.0976310729 9.70710678,0.292893219 L12,2.58578644 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.000000, 2.500000) scale(1, -1) translate(-12.000000, -2.500000) "/>
														   </g>
													   </svg>
   
												   </span> <span> Account Information</span> </span>
													   </a>
												   </li>
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_4" role="tab" class="nav-link kt-widget__item"> <span class="kt-widget__section">
												<span class="kt-widget__icon">
												 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
												   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													   <rect x="0" y="0" width="24" height="24" />
													   <path d="M6,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 L5,3 C5,2.44771525 5.44771525,2 6,2 Z M7.5,5 C7.22385763,5 7,5.22385763 7,5.5 C7,5.77614237 7.22385763,6 7.5,6 L13.5,6 C13.7761424,6 14,5.77614237 14,5.5 C14,5.22385763 13.7761424,5 13.5,5 L7.5,5 Z M7.5,7 C7.22385763,7 7,7.22385763 7,7.5 C7,7.77614237 7.22385763,8 7.5,8 L10.5,8 C10.7761424,8 11,7.77614237 11,7.5 C11,7.22385763 10.7761424,7 10.5,7 L7.5,7 Z" fill="#000000" opacity="0.3" />
													   <path d="M3.79274528,6.57253826 L12,12.5 L20.2072547,6.57253826 C20.4311176,6.4108595 20.7436609,6.46126971 20.9053396,6.68513259 C20.9668779,6.77033951 21,6.87277228 21,6.97787787 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6.97787787 C3,6.70173549 3.22385763,6.47787787 3.5,6.47787787 C3.60510559,6.47787787 3.70753836,6.51099993 3.79274528,6.57253826 Z" fill="#000000" />
												   </g>
											   </svg> 
										   </span> <span>KYC(Know Your Customer)</span> </span>
													   </a>
												   </li>
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_6" role="tab" class="nav-link kt-widget__item"> <span class="kt-widget__section">
													   <span class="kt-widget__icon">	 
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															   <rect x="0" y="0" width="24" height="24"></rect>
															   <path d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z" fill="#000000" opacity="0.3"></path>
															   <path d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z" fill="#000000"></path>
														   </g>
													   </svg>
													 </span> <span>Notification Center</span> </span>
													   </a>
												   </li>
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_3" role="tab" class="nav-link kt-widget__item"> <span class="kt-widget__section">
													 <span class="kt-widget__icon">
														 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															   <rect opacity="0.200000003" x="0" y="0" width="24" height="24"/>
															   <path d="M4.5,7 L9.5,7 C10.3284271,7 11,7.67157288 11,8.5 C11,9.32842712 10.3284271,10 9.5,10 L4.5,10 C3.67157288,10 3,9.32842712 3,8.5 C3,7.67157288 3.67157288,7 4.5,7 Z M13.5,15 L18.5,15 C19.3284271,15 20,15.6715729 20,16.5 C20,17.3284271 19.3284271,18 18.5,18 L13.5,18 C12.6715729,18 12,17.3284271 12,16.5 C12,15.6715729 12.6715729,15 13.5,15 Z" fill="#000000" opacity="0.3"/>
															   <path d="M17,11 C15.3431458,11 14,9.65685425 14,8 C14,6.34314575 15.3431458,5 17,5 C18.6568542,5 20,6.34314575 20,8 C20,9.65685425 18.6568542,11 17,11 Z M6,19 C4.34314575,19 3,17.6568542 3,16 C3,14.3431458 4.34314575,13 6,13 C7.65685425,13 9,14.3431458 9,16 C9,17.6568542 7.65685425,19 6,19 Z" fill="#000000"/>
														   </g>
													   </svg>
													 </span> <span>Change Password</span> </span>
													   </a>
												   </li>
												   <li class="nav-item">
													   <a data-toggle="tab" href="#kt_user_edit_tab_7" role="tab" class="nav-link kt-widget__item"> <span class="kt-widget__section">
													   <span class="kt-widget__icon">	 
														<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															   <rect x="0" y="0" width="24" height="24"/>
															   <path d="M7.62302337,5.30262097 C8.08508802,5.000107 8.70490146,5.12944838 9.00741543,5.59151303 C9.3099294,6.05357769 9.18058801,6.67339112 8.71852336,6.97590509 C7.03468892,8.07831239 6,9.95030239 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,9.99549229 17.0108275,8.15969002 15.3875704,7.04698597 C14.9320347,6.73472706 14.8158858,6.11230651 15.1281448,5.65677076 C15.4404037,5.20123501 16.0628242,5.08508618 16.51836,5.39734508 C18.6800181,6.87911023 20,9.32886071 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,9.26852332 5.38056879,6.77075716 7.62302337,5.30262097 Z" fill="#000000" fill-rule="nonzero"/>
															   <rect fill="#000000" opacity="0.3" x="11" y="3" width="2" height="10" rx="1"/>
														   </g>
													   </svg>
													 </span> <span>Close and Delete Account</span> </span>
													   </a>
												   </li>
											   </ul>
										   </div>
									   </div>
									 </div>
									  <!--end::Widget -->
								   </div>
								</div>
								<!--end:: Widgets/Applications/User/Profile1-->
							   </div>
							   <!--End:: App Aside-->
							   <!--Begin:: App Content-->
						   <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
							<div class="row">
							 <div class="col-xl-12 col-lg-12">
							   <div class="kt-portlet ">
								<form action="" method="">
								 <div class="tab-content">
								   <div class="tab-pane active" id="kt_user_edit_tab_1" role="tabpanel">
									   <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12 col-lg-12">
												   <div class="kt-portlet">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">Personal Information <small>update your personal informaiton</small></h3> 
														   </div>
														   <div class="kt-portlet__head-toolbar">
														   <div class="kt-portlet__head-wrapper">
															   <div class="dropdown dropdown-inline">
																   <button type="button" class="btn btn-label-brand btn-sm btn-icon btn-icon-md">
																	   <i class="flaticon2-user"></i>
																   </button>
															   </div>
														   </div>
													   </div>
													   </div>
													   <form class="kt-form kt-form--label-right">
														   <div class="kt-portlet__body">
															   <div class="kt-section kt-section--first">
																   <div class="kt-section__body">
																	   <div class="form-group row mt-5">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Avatar</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <div class="kt-avatar kt-avatar--outline" id="kt_user_avatar">
																				   <div class="kt-avatar__holder" style="background-image: url(&quot;./assets/image/user.png&quot;);"></div>
																				   <label class="text-left kt-avatar__upload" data-toggle="kt-tooltip" title="" data-original-title="Change avatar"> <i class="la la-pencil"></i>
																					   <input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg"> </label> <span class="kt-avatar__cancel" data-toggle="kt-tooltip" title="" data-original-title="Cancel avatar">
																			   <i class="fa fa-times"></i>
																		   </span> </div>
																		   </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">First Name</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input class="form-control" type="text"> </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Last Name</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input class="form-control" type="text"> </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Contact Phone</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <div class="input-group">
																				   <div class="input-group-prepend"><span class="input-group-text"><i class="la la-phone"></i></span></div>
																				   <input type="text" class="form-control"> 
																			   </div>
																		   </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Email Address</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <div class="input-group">
																				   <div class="input-group-prepend"><span class="input-group-text"><i class="la la-at"></i></span></div>
																				   <input type="text" class="form-control"> 
																			   </div>
																		   </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Location:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <select name="country" class="form-control">
																				   <option value="">Select</option>
																				   <option value="AF">Afghanistan</option>
																				   <option value="AX">Åland Islands</option>
																				   <option value="AL">Albania</option>
																				   <option value="DZ">Algeria</option>
																				   <option value="AS">American Samoa</option>
																				   <option value="AD">Andorra</option>
																				   <option value="AO">Angola</option>
																				   <option value="AI">Anguilla</option>
																				   <option value="AQ">Antarctica</option>
																				   <option value="AG">Antigua and Barbuda</option>
																				   <option value="AR">Argentina</option>
																				   <option value="AM">Armenia</option>
																				   <option value="AW">Aruba</option>
																				   <option value="AU" selected="">Australia</option>
																				   <option value="AT">Austria</option>
																				   <option value="AZ">Azerbaijan</option>
																				   <option value="BS">Bahamas</option>
																				   <option value="BH">Bahrain</option>
																				   <option value="BD">Bangladesh</option>
																				   <option value="BB">Barbados</option>
																				   <option value="BY">Belarus</option>
																				   <option value="BE">Belgium</option>
																				   <option value="BZ">Belize</option>
																				   <option value="BJ">Benin</option>
																				   <option value="BM">Bermuda</option>
																				   <option value="BT">Bhutan</option>
																				   <option value="BO">Bolivia, Plurinational State of</option>
																				   <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
																				   <option value="BA">Bosnia and Herzegovina</option>
																				   <option value="BW">Botswana</option>
																				   <option value="BV">Bouvet Island</option>
																				   <option value="BR">Brazil</option>
																				   <option value="IO">British Indian Ocean Territory</option>
																				   <option value="BN">Brunei Darussalam</option>
																				   <option value="BG">Bulgaria</option>
																				   <option value="BF">Burkina Faso</option>
																				   <option value="BI">Burundi</option>
																				   <option value="KH">Cambodia</option>
																				   <option value="CM">Cameroon</option>
																				   <option value="CA">Canada</option>
																				   <option value="CV">Cape Verde</option>
																				   <option value="KY">Cayman Islands</option>
																				   <option value="CF">Central African Republic</option>
																				   <option value="TD">Chad</option>
																				   <option value="CL">Chile</option>
																				   <option value="CN">China</option>
																				   <option value="CX">Christmas Island</option>
																				   <option value="CC">Cocos (Keeling) Islands</option>
																				   <option value="CO">Colombia</option>
																				   <option value="KM">Comoros</option>
																				   <option value="CG">Congo</option>
																				   <option value="CD">Congo, the Democratic Republic of the</option>
																				   <option value="CK">Cook Islands</option>
																				   <option value="CR">Costa Rica</option>
																				   <option value="CI">Côte d'Ivoire</option>
																				   <option value="HR">Croatia</option>
																				   <option value="CU">Cuba</option>
																				   <option value="CW">Curaçao</option>
																				   <option value="CY">Cyprus</option>
																				   <option value="CZ">Czech Republic</option>
																				   <option value="DK">Denmark</option>
																				   <option value="DJ">Djibouti</option>
																				   <option value="DM">Dominica</option>
																				   <option value="DO">Dominican Republic</option>
																				   <option value="EC">Ecuador</option>
																				   <option value="EG">Egypt</option>
																				   <option value="SV">El Salvador</option>
																				   <option value="GQ">Equatorial Guinea</option>
																				   <option value="ER">Eritrea</option>
																				   <option value="EE">Estonia</option>
																				   <option value="ET">Ethiopia</option>
																				   <option value="FK">Falkland Islands (Malvinas)</option>
																				   <option value="FO">Faroe Islands</option>
																				   <option value="FJ">Fiji</option>
																				   <option value="FI">Finland</option>
																				   <option value="FR">France</option>
																				   <option value="GF">French Guiana</option>
																				   <option value="PF">French Polynesia</option>
																				   <option value="TF">French Southern Territories</option>
																				   <option value="GA">Gabon</option>
																				   <option value="GM">Gambia</option>
																				   <option value="GE">Georgia</option>
																				   <option value="DE">Germany</option>
																				   <option value="GH">Ghana</option>
																				   <option value="GI">Gibraltar</option>
																				   <option value="GR">Greece</option>
																				   <option value="GL">Greenland</option>
																				   <option value="GD">Grenada</option>
																				   <option value="GP">Guadeloupe</option>
																				   <option value="GU">Guam</option>
																				   <option value="GT">Guatemala</option>
																				   <option value="GG">Guernsey</option>
																				   <option value="GN">Guinea</option>
																				   <option value="GW">Guinea-Bissau</option>
																				   <option value="GY">Guyana</option>
																				   <option value="HT">Haiti</option>
																				   <option value="HM">Heard Island and McDonald Islands</option>
																				   <option value="VA">Holy See (Vatican City State)</option>
																				   <option value="HN">Honduras</option>
																				   <option value="HK">Hong Kong</option>
																				   <option value="HU">Hungary</option>
																				   <option value="IS">Iceland</option>
																				   <option value="IN" selected>India</option>
																				   <option value="ID">Indonesia</option>
																				   <option value="IR">Iran, Islamic Republic of</option>
																				   <option value="IQ">Iraq</option>
																				   <option value="IE">Ireland</option>
																				   <option value="IM">Isle of Man</option>
																				   <option value="IL">Israel</option>
																				   <option value="IT">Italy</option>
																				   <option value="JM">Jamaica</option>
																				   <option value="JP">Japan</option>
																				   <option value="JE">Jersey</option>
																				   <option value="JO">Jordan</option>
																				   <option value="KZ">Kazakhstan</option>
																				   <option value="KE">Kenya</option>
																				   <option value="KI">Kiribati</option>
																				   <option value="KP">Korea, Democratic People's Republic of</option>
																				   <option value="KR">Korea, Republic of</option>
																				   <option value="KW">Kuwait</option>
																				   <option value="KG">Kyrgyzstan</option>
																				   <option value="LA">Lao People's Democratic Republic</option>
																				   <option value="LV">Latvia</option>
																				   <option value="LB">Lebanon</option>
																				   <option value="LS">Lesotho</option>
																				   <option value="LR">Liberia</option>
																				   <option value="LY">Libya</option>
																				   <option value="LI">Liechtenstein</option>
																				   <option value="LT">Lithuania</option>
																				   <option value="LU">Luxembourg</option>
																				   <option value="MO">Macao</option>
																				   <option value="MK">Macedonia, the former Yugoslav Republic of</option>
																				   <option value="MG">Madagascar</option>
																				   <option value="MW">Malawi</option>
																				   <option value="MY">Malaysia</option>
																				   <option value="MV">Maldives</option>
																				   <option value="ML">Mali</option>
																				   <option value="MT">Malta</option>
																				   <option value="MH">Marshall Islands</option>
																				   <option value="MQ">Martinique</option>
																				   <option value="MR">Mauritania</option>
																				   <option value="MU">Mauritius</option>
																				   <option value="YT">Mayotte</option>
																				   <option value="MX">Mexico</option>
																				   <option value="FM">Micronesia, Federated States of</option>
																				   <option value="MD">Moldova, Republic of</option>
																				   <option value="MC">Monaco</option>
																				   <option value="MN">Mongolia</option>
																				   <option value="ME">Montenegro</option>
																				   <option value="MS">Montserrat</option>
																				   <option value="MA">Morocco</option>
																				   <option value="MZ">Mozambique</option>
																				   <option value="MM">Myanmar</option>
																				   <option value="NA">Namibia</option>
																				   <option value="NR">Nauru</option>
																				   <option value="NP">Nepal</option>
																				   <option value="NL">Netherlands</option>
																				   <option value="NC">New Caledonia</option>
																				   <option value="NZ">New Zealand</option>
																				   <option value="NI">Nicaragua</option>
																				   <option value="NE">Niger</option>
																				   <option value="NG">Nigeria</option>
																				   <option value="NU">Niue</option>
																				   <option value="NF">Norfolk Island</option>
																				   <option value="MP">Northern Mariana Islands</option>
																				   <option value="NO">Norway</option>
																				   <option value="OM">Oman</option>
																				   <option value="PK">Pakistan</option>
																				   <option value="PW">Palau</option>
																				   <option value="PS">Palestinian Territory, Occupied</option>
																				   <option value="PA">Panama</option>
																				   <option value="PG">Papua New Guinea</option>
																				   <option value="PY">Paraguay</option>
																				   <option value="PE">Peru</option>
																				   <option value="PH">Philippines</option>
																				   <option value="PN">Pitcairn</option>
																				   <option value="PL">Poland</option>
																				   <option value="PT">Portugal</option>
																				   <option value="PR">Puerto Rico</option>
																				   <option value="QA">Qatar</option>
																				   <option value="RE">Réunion</option>
																				   <option value="RO">Romania</option>
																				   <option value="RU">Russian Federation</option>
																				   <option value="RW">Rwanda</option>
																				   <option value="BL">Saint Barthélemy</option>
																				   <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
																				   <option value="KN">Saint Kitts and Nevis</option>
																				   <option value="LC">Saint Lucia</option>
																				   <option value="MF">Saint Martin (French part)</option>
																				   <option value="PM">Saint Pierre and Miquelon</option>
																				   <option value="VC">Saint Vincent and the Grenadines</option>
																				   <option value="WS">Samoa</option>
																				   <option value="SM">San Marino</option>
																				   <option value="ST">Sao Tome and Principe</option>
																				   <option value="SA">Saudi Arabia</option>
																				   <option value="SN">Senegal</option>
																				   <option value="RS">Serbia</option>
																				   <option value="SC">Seychelles</option>
																				   <option value="SL">Sierra Leone</option>
																				   <option value="SG">Singapore</option>
																				   <option value="SX">Sint Maarten (Dutch part)</option>
																				   <option value="SK">Slovakia</option>
																				   <option value="SI">Slovenia</option>
																				   <option value="SB">Solomon Islands</option>
																				   <option value="SO">Somalia</option>
																				   <option value="ZA">South Africa</option>
																				   <option value="GS">South Georgia and the South Sandwich Islands</option>
																				   <option value="SS">South Sudan</option>
																				   <option value="ES">Spain</option>
																				   <option value="LK">Sri Lanka</option>
																				   <option value="SD">Sudan</option>
																				   <option value="SR">Suriname</option>
																				   <option value="SJ">Svalbard and Jan Mayen</option>
																				   <option value="SZ">Swaziland</option>
																				   <option value="SE">Sweden</option>
																				   <option value="CH">Switzerland</option>
																				   <option value="SY">Syrian Arab Republic</option>
																				   <option value="TW">Taiwan, Province of China</option>
																				   <option value="TJ">Tajikistan</option>
																				   <option value="TZ">Tanzania, United Republic of</option>
																				   <option value="TH">Thailand</option>
																				   <option value="TL">Timor-Leste</option>
																				   <option value="TG">Togo</option>
																				   <option value="TK">Tokelau</option>
																				   <option value="TO">Tonga</option>
																				   <option value="TT">Trinidad and Tobago</option>
																				   <option value="TN">Tunisia</option>
																				   <option value="TR">Turkey</option>
																				   <option value="TM">Turkmenistan</option>
																				   <option value="TC">Turks and Caicos Islands</option>
																				   <option value="TV">Tuvalu</option>
																				   <option value="UG">Uganda</option>
																				   <option value="UA">Ukraine</option>
																				   <option value="AE">United Arab Emirates</option>
																				   <option value="GB">United Kingdom</option>
																				   <option value="US">United States</option>
																				   <option value="UM">United States Minor Outlying Islands</option>
																				   <option value="UY">Uruguay</option>
																				   <option value="UZ">Uzbekistan</option>
																				   <option value="VU">Vanuatu</option>
																				   <option value="VE">Venezuela, Bolivarian Republic of</option>
																				   <option value="VN">Viet Nam</option>
																				   <option value="VG">Virgin Islands, British</option>
																				   <option value="VI">Virgin Islands, U.S.</option>
																				   <option value="WF">Wallis and Futuna</option>
																				   <option value="EH">Western Sahara</option>
																				   <option value="YE">Yemen</option>
																				   <option value="ZM">Zambia</option>
																				   <option value="ZW">Zimbabwe</option>
																			   </select>
																		   </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Profile Title:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input class="form-control" type="text" placeholder="e.g. Data Scientist">
																		   </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Linkedin Profile:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input class="form-control" type="text">
																		   </div>
																	   </div>
																	   <div class="form-group row">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Profile Description:</label>
																		   <div class="col-lg-8 col-xl-8">
																			  <textarea rows="5" class="form-control"></textarea>
																		   </div>
																	   </div>
																   </div>
															   </div>
														   </div>
														   <div class="kt-portlet__foot">
															   <div class="kt-form__actions">
																   <div class="row">
																	   <div class="col-lg-5 col-xl-5"> </div>
																	   <button class="btn btn-success">Submit</button> 
																   </div>
															   </div>
														   </div>
													   </form>
												   </div>
											   </div>
										   </div>
									   </div>
								   </div>
								   <div class="tab-pane" id="kt_user_edit_tab_2" role="tabpanel">
								   	 <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12 col-lg-12">
												   <div class="kt-portlet">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">Account Information<small>Change your account settings</small></h3> 
														   </div>
														   <div class="kt-portlet__head-toolbar">
														   <div class="kt-portlet__head-wrapper">
															   <div class="dropdown dropdown-inline">
																   <button type="button" class="btn btn-label-brand btn-sm btn-icon btn-icon-md">
																		<i class="flaticon2-pen"></i>
																	</button>
															   </div>
														   </div>
													   </div>
													   </div>
													   <form class="kt-form kt-form--label-right">
														   <div class="kt-portlet__body">
															   <div class="kt-section kt-section--first">
																   <div class="kt-section__body">
																	   <div class="form-group row mt-5 mb-5">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Types of Organization:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <select class="form-control">
																				   <option value="Individual">Individual</option>
																				   <option value="Student or Research Scholar"> Student or Research Scholar</option>
																				   <option value="Public Research"> Public Research</option>
																				   <option value="Non-Profit Organization"> Non-Profit Organization</option>
																				   <option value="Private Owned Enterprise"> Private Owned Enterprise</option>
																			   </select>
																		   </div>
																	   </div>
																	   <div class="form-group row mb-5">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Business Category:</label>
																		   <div class="col-lg-8 col-xl-8">
																				<select class="form-control">
																						<option value="Aeronautics & Defence">Aeronautics & Defence</option>
																						<option value="Agriculture,Agrifood">Agriculture  & Agrifood</option>
																						<option value="Automotive"> Automotive</option>
																						<option value="Chemical Industry"> Chemical Industry</option>
																						<option value="Consulting Management"> Consulting & Management</option>
																						<option value="Commerce, E-commerce"> Commerce & E-commerce</option>
																						<option value="Education ,Training"> Education & Training</option>
																						<option value="Environment, Energy"> Environment & Energy</option>
																						<option value="Marketing Branding">Marketing & Branding</option>
																						<option value="Engineering, Construction">Engineering & Construction</option>
																						<option value="Healthcare"> Healthcare</option>
																						<option value="Life Sources">Life Sciences</option>
																						<option value="Media,Publishing"> Media & Publishing</option>
																						<option value="Non-Profit,Social">Non-Profit & Social</option>
																						<option value="Public Sector">Public Sector</option>
																						<option value="Real Estate"> Real Estate</option>
																						<option value="Sports,Leisure">Sports & Leisure</option>
																						<option value="Technology, IT"> Technology & IT</option>
																						<option value="Telecom">Telecom</option>
																						<option value="Transport,Logistic"> Transport & Logistics</option>
																						<option value="Travel,Tourism"> Travel & Tourism</option>
																						<option value="Utility Bills"> Utility Bills</option>
																						<option value="Other"> Other</option>
																					</select>
																		   </div>
																	   </div>
																	   <div class="form-group row mb-5">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Interest Areas:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input  name="interest" value="Medical">
																		   </div>
																	   </div>
																	   <div class="form-group row  mb-5">
																		   <label class="text-left col-xl-4 col-lg-4 col-form-label">Objective:</label>
																		   <div class="col-lg-8 col-xl-8">
																				<angular2-multiselect [data]="dropdownList" [(ngModel)]="selectedItems"  [settings]="dropdownSettings" name="Objective" #Objective>	
																				</angular2-multiselect>
																		   </div>
																	   </div>
																	   <div class="form-group row  mb-5">
																		   <label class="text-left col-xl-4 col-lg-4  col-form-label">Website:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <div class="input-group">
																				   <input type="text" class="form-control">
																				   <div class="input-group-append">
																					  <span class="input-group-text">.com</span>
																				   </div>
																			   </div>
																		   </div>
																	   </div>
																	   <div class="form-group row  mb-5">
																		   <label class="text-left col-xl-4 col-lg-4  col-form-label">GSTIN:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <div class="input-group">
																				   <input type="text" class="form-control">
																			   </div>
																		   </div>
																	   </div>
																	   <div class="form-group row  mb-5">
																		   <label class="text-left col-xl-4 col-lg-4  col-form-label">Passport:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <div class="input-group">
																				   <input type="text" class="form-control">
																			   </div>
																		   </div>
																	   </div>
																	   <hr>
																	   <div class="form-group row button">
																		   <button class="btn btn-success">Submit</button> 
																	   </div>
																   </div>
															   </div>
														   </div>
													   </form>
													</div>
												</div>
											</div>
										</div>
								   </div>
								   <div class="tab-pane" id="kt_user_edit_tab_3" role="tabpanel">
								   	  <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12 col-lg-12">
												   <div class="kt-portlet">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">Change Password<small>Change or Reset your Account Password</small></h3> 
														   </div>
														   <div class="kt-portlet__head-toolbar">
														   <div class="kt-portlet__head-wrapper">
															   <div class="dropdown dropdown-inline">
																   <button type="button" class="btn btn-label-brand btn-sm btn-icon btn-icon-md">
																		<i class="flaticon2-console"></i>
																	</button>
															   </div>
														   </div>
													   </div>
													   </div>
													   <form class="kt-form kt-form--label-right">
														   <div class="kt-portlet__body">
															   <div class="kt-section kt-section--first">
																   <div class="kt-section__body">
																	   <div class="form-group row mt-5 mb-5">
																		   <label class="text-left Col-lg-4 col-xl-4 col-form-label">Current Password:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input type="password" class="form-control"> <a href="#" class="fp">Forgot Password?</a> </div>
																	   </div>
																	   <div class="form-group row mb-5">
																		   <label class="text-left Col-lg-4 col-xl-4 col-form-label">New Password:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input type="password" class="form-control"> </div>
																	   </div>
																	   <div class="form-group row mb-5">
																		   <label class="text-left Col-lg-4 col-xl-4 col-form-label">Verify Password:</label>
																		   <div class="col-lg-8 col-xl-8">
																			   <input type="password" class="form-control"> </div>
																	   </div>
																	   <hr>
																	   <div class="form-group row button">
																		   <button class="btn btn-primary">Change Password </button>
																	   </div>
																   </div>
															   </div>
														   </div>
													   </form>
													</div>
												</div>
											</div>
										</div>
								   </div>
								   <div class="tab-pane" id="kt_user_edit_tab_4" role="tabpanel">
								   	 <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12 col-lg-12">
												   <div class="kt-portlet">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">KYC<small>Know Your Customer</small></h3> 
														   </div>
														   <div class="kt-portlet__head-toolbar">
														   <div class="kt-portlet__head-wrapper">
															   <div class="dropdown dropdown-inline">
																   <button type="button" class="btn btn-label-brand btn-sm btn-icon btn-icon-md">
																	   <i class="flaticon2-infographic"></i>
																   </button>
															   </div>
														   </div>
													   </div>
													   </div>
													   <form class="kt-form kt-form--label-right">
														   <div class="kt-portlet__body">
															   <div class="kt-section kt-section--first">
																   <div class="kt-section__body">
																	   <div class="row mt-3">
																		   <div class="col-lg-12 col-xl-12 kyc_text">
																			   The Know Your Customer (“KYC”) system is a process adopted by banks and payment intermediaries to collect all information about their customers, aiming to improve their identification, to combat identity theft, and any risks of money laundering, fraud and financial crime.
				   
																		   </div>
																		</div>
																		   <div class="row mt-3 mb-5">
																		   <div class="col-lg-12 col-xl-12 kyc_text">
																			   To carry out a transaction on DataPitcher, each member must have sent the documents required for KYC. The payment and data will be held until the KYC has been validated for each party. You will only be asked for this information once; it is then valid for all your future operations on our platform.
				   
																		   </div>
																	   </div>
																	   <div class="form-group row mt-5 ml-2">
																		   <label class="text-left col-lg-4 col-xl-4 col-form-label">Identity Documents:</label>
																		   <input type="file" name="file" hidden="" id="identify_document">
																		   <span class="col-xl-4 col-lg-4 form-control"></span>
																		   <button class="btn btn-label-brand btn-bold col-xl-2 col-lg-2 ml-1 form-control" (click)="onClick($event)">Upload</button>
																		   <div class="col-lg-1 col-xl-1">
				                                                             <img src="./assets/image/info.png">
				                                                           </div>
				                                                           <span class="form-text text-muted offset-lg-4 offset-xl-4 kyc_text_file_info">Max 10 MB. Accepted Formats:PNG,JPG JPEG,PDF,DOC,GIF</span>
																	   </div>
																	   <hr>
																	   <div class="form-group row button">
																		   <button class="btn btn-success">Submit</button> 
																	   </div>
																   </div>
															   </div>
														   </div>
													   </form>
													</div>
												</div>
											</div>
										</div>
								   </div>
								   <div class="tab-pane" id="kt_user_edit_tab_5" role="tabpanel">
									   <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12">
												   <!--begin:: Widgets/Order Statistics-->
												   <div class="kt-portlet kt-portlet--height-fluid">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">
														   Order Statistics
													   </h3> </div>
														   <div class="kt-portlet__head-toolbar"> <a href="#" class="btn btn-label-brand btn-bold btn-sm dropdown-toggle explore" data-toggle="dropdown" aria-expanded="false">
														   Export
													   </a>
															   <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right show dropdown-menu-anim-explore d-none" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(274px, 45px, 0px);">
																   <!--begin::Nav-->
																   <ul class="kt-nav">
																	   <li class="kt-nav__head"> Export Options <span data-toggle="kt-tooltip" data-placement="right" title="" data-original-title="Click to learn more...">
														   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand kt-svg-icon--md1">
															   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																   <rect x="0" y="0" width="24" height="24"></rect>
																   <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"></circle>
																   <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"></rect>
																   <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"></rect>
															   </g>
														   </svg> </span> </li>
																	   <li class="kt-nav__separator"></li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-drop"></i> <span class="kt-nav__link-text">Activity</span> </a>
																	   </li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-calendar-8"></i> <span class="kt-nav__link-text">FAQ</span> </a>
																	   </li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-telegram-logo"></i> <span class="kt-nav__link-text">Settings</span> </a>
																	   </li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-new-email"></i> <span class="kt-nav__link-text">Support</span> <span class="kt-nav__link-badge">
																		   <span class="kt-badge kt-badge--success kt-badge--rounded">5</span> </span>
																		   </a>
																	   </li>
																	   <li class="kt-nav__separator"></li>
																	   <li class="kt-nav__foot"> <a class="btn btn-label-danger btn-bold btn-sm" href="#">Upgrade plan</a> <a class="btn btn-clean btn-bold btn-sm" href="#" data-toggle="kt-tooltip" data-placement="right" title="" data-original-title="Click to learn more...">Learn more</a> </li>
																   </ul>
																   <!--end::Nav-->
															   </div>
														   </div>
													   </div>
													   <div class="kt-portlet__body kt-portlet__body--fluid">
														   <div class="kt-widget12">
															   <div class="kt-widget12__content">
																   <div class="kt-widget12__item">
																	   <div class="kt-widget12__info"> <span class="kt-widget12__desc">Annual Taxes EMS</span> <span class="kt-widget12__value">$400,000</span> </div>
																	   <div class="kt-widget12__info"> <span class="kt-widget12__desc">Finance Review Date</span> <span class="kt-widget12__value">July 24,2019</span> </div>
																   </div>
																   <div class="kt-widget12__item">
																	   <div class="kt-widget12__info"> <span class="kt-widget12__desc">Avarage Revenue</span> <span class="kt-widget12__value">$60M</span> </div>
																	   <div class="kt-widget12__info"> <span class="kt-widget12__desc">Revenue Margin</span>
																		   <div class="kt-widget12__progress">
																			   <div class="progress kt-progress--sm">
																				   <div class="progress-bar kt-bg-brand" role="progressbar" style="width: 40%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
																			   </div> <span class="kt-widget12__stat">
																		   40%
																	   </span> </div>
																	   </div>
																   </div>
															   </div>
															   <div class="kt-widget12__chart">
																   <canvas id="kt_chart_order_statistics"></canvas>
															   </div>
														   </div>
													   </div>
												   </div>
												   <!--end:: Widgets/Order Statistics-->
											   </div>
											   <div class="col-xl-12">
												   <!--begin:: Widgets/Notifications -->
												   <div class="kt-portlet kt-portlet--height-fluid">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">
														   Notifications
													   </h3> </div>
														   <div class="kt-portlet__head-toolbar">
															   <ul class="nav nav-pills nav-pills-sm nav-pills-label nav-pills-bold" role="tablist">
																   <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#kt_widget6_tab1_content" role="tab" aria-selected="false">
																   Latest
															   </a> </li>
																   <li class="nav-item"> <a class="nav-link active" data-toggle="tab" href="#kt_widget6_tab2_content" role="tab" aria-selected="true">
																   Week
															   </a> </li>
																   <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#kt_widget6_tab3_content" role="tab" aria-selected="false">
																   Month
															   </a> </li>
															   </ul>
														   </div>
													   </div>
													   <div class="kt-portlet__body">
														   <div class="tab-content">
															   <div class="tab-pane" id="kt_widget6_tab1_content" aria-expanded="true">
																   <div class="kt-notification">
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#000000"></path>
																					   <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519) " x="16.3255682" y="2.94551858" width="3" height="18" rx="1"></rect>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New order has been received. </div>
																			   <div class="kt-notification__item-time"> 2 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M12.9835977,18 C12.7263047,14.0909841 9.47412135,11 5.5,11 C4.98630124,11 4.48466491,11.0516454 4,11.1500272 L4,7 C4,5.8954305 4.8954305,5 6,5 L20,5 C21.1045695,5 22,5.8954305 22,7 L22,16 C22,17.1045695 21.1045695,18 20,18 L12.9835977,18 Z M19.1444251,6.83964668 L13,10.1481833 L6.85557487,6.83964668 C6.4908718,6.6432681 6.03602525,6.77972206 5.83964668,7.14442513 C5.6432681,7.5091282 5.77972206,7.96397475 6.14442513,8.16035332 L12.6444251,11.6603533 C12.8664074,11.7798822 13.1335926,11.7798822 13.3555749,11.6603533 L19.8555749,8.16035332 C20.2202779,7.96397475 20.3567319,7.5091282 20.1603533,7.14442513 C19.9639747,6.77972206 19.5091282,6.6432681 19.1444251,6.83964668 Z" fill="#000000"></path>
																					   <path d="M8.4472136,18.1055728 C8.94119209,18.3525621 9.14141644,18.9532351 8.89442719,19.4472136 C8.64743794,19.9411921 8.0467649,20.1414164 7.5527864,19.8944272 L5,18.618034 L5,14.5 C5,13.9477153 5.44771525,13.5 6,13.5 C6.55228475,13.5 7,13.9477153 7,14.5 L7,17.381966 L8.4472136,18.1055728 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New member is registered and pending for approval. </div>
																			   <div class="kt-notification__item-time"> 3 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M12,10.9996338 C12.8356605,10.3719448 13.8743941,10 15,10 C17.7614237,10 20,12.2385763 20,15 C20,17.7614237 17.7614237,20 15,20 C13.8743941,20 12.8356605,19.6280552 12,19.0003662 C11.1643395,19.6280552 10.1256059,20 9,20 C6.23857625,20 4,17.7614237 4,15 C4,12.2385763 6.23857625,10 9,10 C10.1256059,10 11.1643395,10.3719448 12,10.9996338 Z M13.3336047,12.504354 C13.757474,13.2388026 14,14.0910788 14,15 C14,15.9088933 13.7574889,16.761145 13.3336438,17.4955783 C13.8188886,17.8206693 14.3938466,18 15,18 C16.6568542,18 18,16.6568542 18,15 C18,13.3431458 16.6568542,12 15,12 C14.3930587,12 13.8175971,12.18044 13.3336047,12.504354 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
																					   <circle fill="#000000" cx="12" cy="9" r="5"></circle>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> Membership application has been added. </div>
																			   <div class="kt-notification__item-time"> 3 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <polygon points="0 0 24 0 24 24 0 24"></polygon>
																					   <path d="M18.5,8 C17.1192881,8 16,6.88071187 16,5.5 C16,4.11928813 17.1192881,3 18.5,3 C19.8807119,3 21,4.11928813 21,5.5 C21,6.88071187 19.8807119,8 18.5,8 Z M18.5,21 C17.1192881,21 16,19.8807119 16,18.5 C16,17.1192881 17.1192881,16 18.5,16 C19.8807119,16 21,17.1192881 21,18.5 C21,19.8807119 19.8807119,21 18.5,21 Z M5.5,21 C4.11928813,21 3,19.8807119 3,18.5 C3,17.1192881 4.11928813,16 5.5,16 C6.88071187,16 8,17.1192881 8,18.5 C8,19.8807119 6.88071187,21 5.5,21 Z" fill="#000000" opacity="0.3"></path>
																					   <path d="M5.5,8 C4.11928813,8 3,6.88071187 3,5.5 C3,4.11928813 4.11928813,3 5.5,3 C6.88071187,3 8,4.11928813 8,5.5 C8,6.88071187 6.88071187,8 5.5,8 Z M11,4 L13,4 C13.5522847,4 14,4.44771525 14,5 C14,5.55228475 13.5522847,6 13,6 L11,6 C10.4477153,6 10,5.55228475 10,5 C10,4.44771525 10.4477153,4 11,4 Z M11,18 L13,18 C13.5522847,18 14,18.4477153 14,19 C14,19.5522847 13.5522847,20 13,20 L11,20 C10.4477153,20 10,19.5522847 10,19 C10,18.4477153 10.4477153,18 11,18 Z M5,10 C5.55228475,10 6,10.4477153 6,11 L6,13 C6,13.5522847 5.55228475,14 5,14 C4.44771525,14 4,13.5522847 4,13 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M19,10 C19.5522847,10 20,10.4477153 20,11 L20,13 C20,13.5522847 19.5522847,14 19,14 C18.4477153,14 18,13.5522847 18,13 L18,11 C18,10.4477153 18.4477153,10 19,10 Z" fill="#000000"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New report file has been uploaded. </div>
																			   <div class="kt-notification__item-time"> 5 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M16.3740377,19.9389434 L22.2226499,11.1660251 C22.4524142,10.8213786 22.3592838,10.3557266 22.0146373,10.1259623 C21.8914367,10.0438285 21.7466809,10 21.5986122,10 L17,10 L17,4.47708173 C17,4.06286817 16.6642136,3.72708173 16.25,3.72708173 C15.9992351,3.72708173 15.7650616,3.85240758 15.6259623,4.06105658 L9.7773501,12.8339749 C9.54758575,13.1786214 9.64071616,13.6442734 9.98536267,13.8740377 C10.1085633,13.9561715 10.2533191,14 10.4013878,14 L15,14 L15,19.5229183 C15,19.9371318 15.3357864,20.2729183 15.75,20.2729183 C16.0007649,20.2729183 16.2349384,20.1475924 16.3740377,19.9389434 Z" fill="#000000"></path>
																					   <path d="M4.5,5 L9.5,5 C10.3284271,5 11,5.67157288 11,6.5 C11,7.32842712 10.3284271,8 9.5,8 L4.5,8 C3.67157288,8 3,7.32842712 3,6.5 C3,5.67157288 3.67157288,5 4.5,5 Z M4.5,17 L9.5,17 C10.3284271,17 11,17.6715729 11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L4.5,20 C3.67157288,20 3,19.3284271 3,18.5 C3,17.6715729 3.67157288,17 4.5,17 Z M2.5,11 L6.5,11 C7.32842712,11 8,11.6715729 8,12.5 C8,13.3284271 7.32842712,14 6.5,14 L2.5,14 C1.67157288,14 1,13.3284271 1,12.5 C1,11.6715729 1.67157288,11 2.5,11 Z" fill="#000000" opacity="0.3"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New user feedback received and pending for review. </div>
																			   <div class="kt-notification__item-time"> 8 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M13.2070325,4 C13.0721672,4.47683179 13,4.97998812 13,5.5 C13,8.53756612 15.4624339,11 18.5,11 C19.0200119,11 19.5231682,10.9278328 20,10.7929675 L20,17 C20,18.6568542 18.6568542,20 17,20 L7,20 C5.34314575,20 4,18.6568542 4,17 L4,7 C4,5.34314575 5.34314575,4 7,4 L13.2070325,4 Z" fill="#000000"></path>
																					   <circle fill="#000000" opacity="0.3" cx="18.5" cy="5.5" r="2.5"></circle>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> Database sever #2 has been fully restarted. </div>
																			   <div class="kt-notification__item-time"> 23 hrs ago </div>
																		   </div>
																	   </a>
																   </div>
															   </div>
															   <div class="tab-pane active" id="kt_widget6_tab2_content" aria-expanded="false">
																   <div class="kt-notification">
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--success">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M9.35321926,16.3736278 L16.3544311,10.3706602 C16.5640654,10.1909158 16.5882961,9.87526197 16.4085517,9.66562759 C16.3922584,9.64662485 16.3745611,9.62887247 16.3556091,9.6125202 L9.35439731,3.57169798 C9.14532254,3.39130299 8.82959492,3.41455255 8.64919993,3.62362732 C8.5708616,3.71442013 8.52776329,3.83034375 8.52776329,3.95026134 L8.52776329,15.9940512 C8.52776329,16.2701936 8.75162092,16.4940512 9.02776329,16.4940512 C9.14714624,16.4940512 9.2625893,16.4513356 9.35321926,16.3736278 Z" fill="#000000" transform="translate(12.398118, 9.870355) rotate(-450.000000) translate(-12.398118, -9.870355) "></path>
																					   <rect fill="#000000" opacity="0.3" transform="translate(12.500000, 17.500000) scale(-1, 1) rotate(-270.000000) translate(-12.500000, -17.500000) " x="11" y="11" width="3" height="13" rx="0.5"></rect>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New company application has been approved. </div>
																			   <div class="kt-notification__item-time"> 3 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <rect fill="#000000" opacity="0.3" x="12" y="4" width="3" height="13" rx="1.5"></rect>
																					   <rect fill="#000000" opacity="0.3" x="7" y="9" width="3" height="8" rx="1.5"></rect>
																					   <path d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z" fill="#000000" fill-rule="nonzero"></path>
																					   <rect fill="#000000" opacity="0.3" x="17" y="11" width="3" height="6" rx="1.5"></rect>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New report has been received. </div>
																			   <div class="kt-notification__item-time"> 23 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--danger">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#000000"></path>
																					   <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519) " x="16.3255682" y="2.94551858" width="3" height="18" rx="1"></rect>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New file has been uploaded and pending for review. </div>
																			   <div class="kt-notification__item-time"> 5 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M12,10.9996338 C12.8356605,10.3719448 13.8743941,10 15,10 C17.7614237,10 20,12.2385763 20,15 C20,17.7614237 17.7614237,20 15,20 C13.8743941,20 12.8356605,19.6280552 12,19.0003662 C11.1643395,19.6280552 10.1256059,20 9,20 C6.23857625,20 4,17.7614237 4,15 C4,12.2385763 6.23857625,10 9,10 C10.1256059,10 11.1643395,10.3719448 12,10.9996338 Z M13.3336047,12.504354 C13.757474,13.2388026 14,14.0910788 14,15 C14,15.9088933 13.7574889,16.761145 13.3336438,17.4955783 C13.8188886,17.8206693 14.3938466,18 15,18 C16.6568542,18 18,16.6568542 18,15 C18,13.3431458 16.6568542,12 15,12 C14.3930587,12 13.8175971,12.18044 13.3336047,12.504354 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
																					   <circle fill="#000000" cx="12" cy="9" r="5"></circle>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> Membership application has been added. </div>
																			   <div class="kt-notification__item-time"> 3 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--info">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <polygon points="0 0 24 0 24 24 0 24"></polygon>
																					   <path d="M12,4.25932872 C12.1488635,4.25921584 12.3000368,4.29247316 12.4425657,4.36281539 C12.6397783,4.46014562 12.7994058,4.61977315 12.8967361,4.81698575 L14.9389263,8.95491503 L19.5054023,9.61846284 C20.0519472,9.69788046 20.4306287,10.2053233 20.351211,10.7518682 C20.3195865,10.9695052 20.2170993,11.1706476 20.0596157,11.3241562 L16.7552826,14.545085 L17.5353298,19.0931094 C17.6286908,19.6374458 17.263103,20.1544017 16.7187666,20.2477627 C16.5020089,20.2849396 16.2790408,20.2496249 16.0843804,20.1472858 L12,18 L12,4.25932872 Z" fill="#000000" opacity="0.3"></path>
																					   <path d="M12,4.25932872 L12,18 L7.91561963,20.1472858 C7.42677504,20.4042866 6.82214789,20.2163401 6.56514708,19.7274955 C6.46280801,19.5328351 6.42749334,19.309867 6.46467018,19.0931094 L7.24471742,14.545085 L3.94038429,11.3241562 C3.54490071,10.938655 3.5368084,10.3055417 3.92230962,9.91005817 C4.07581822,9.75257453 4.27696063,9.65008735 4.49459766,9.61846284 L9.06107374,8.95491503 L11.1032639,4.81698575 C11.277344,4.464261 11.6315987,4.25960807 12,4.25932872 Z" fill="#000000"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New customer is registered. </div>
																			   <div class="kt-notification__item-time"> 3 days ago </div>
																		   </div>
																	   </a>
																   </div>
															   </div>
															   <div class="tab-pane" id="kt_widget6_tab3_content" aria-expanded="false">
																   <div class="kt-notification">
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--warning">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z" fill="#000000" opacity="0.3"></path>
																					   <path d="M14.5,11 C15.0522847,11 15.5,11.4477153 15.5,12 L15.5,15 C15.5,15.5522847 15.0522847,16 14.5,16 L9.5,16 C8.94771525,16 8.5,15.5522847 8.5,15 L8.5,12 C8.5,11.4477153 8.94771525,11 9.5,11 L9.5,10.5 C9.5,9.11928813 10.6192881,8 12,8 C13.3807119,8 14.5,9.11928813 14.5,10.5 L14.5,11 Z M12,9 C11.1715729,9 10.5,9.67157288 10.5,10.5 L10.5,11 L13.5,11 L13.5,10.5 C13.5,9.67157288 12.8284271,9 12,9 Z" fill="#000000"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New order has been received. </div>
																			   <div class="kt-notification__item-time"> 2 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--success">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M12,21 C7.581722,21 4,17.418278 4,13 C4,8.581722 7.581722,5 12,5 C16.418278,5 20,8.581722 20,13 C20,17.418278 16.418278,21 12,21 Z" fill="#000000" opacity="0.3"></path>
																					   <path d="M13,5.06189375 C12.6724058,5.02104333 12.3386603,5 12,5 C11.6613397,5 11.3275942,5.02104333 11,5.06189375 L11,4 L10,4 C9.44771525,4 9,3.55228475 9,3 C9,2.44771525 9.44771525,2 10,2 L14,2 C14.5522847,2 15,2.44771525 15,3 C15,3.55228475 14.5522847,4 14,4 L13,4 L13,5.06189375 Z" fill="#000000"></path>
																					   <path d="M16.7099142,6.53272645 L17.5355339,5.70710678 C17.9260582,5.31658249 18.5592232,5.31658249 18.9497475,5.70710678 C19.3402718,6.09763107 19.3402718,6.73079605 18.9497475,7.12132034 L18.1671361,7.90393167 C17.7407802,7.38854954 17.251061,6.92750259 16.7099142,6.53272645 Z" fill="#000000"></path>
																					   <path d="M11.9630156,7.5 L12.0369844,7.5 C12.2982526,7.5 12.5154733,7.70115317 12.5355117,7.96165175 L12.9585886,13.4616518 C12.9797677,13.7369807 12.7737386,13.9773481 12.4984096,13.9985272 C12.4856504,13.9995087 12.4728582,14 12.4600614,14 L11.5399386,14 C11.2637963,14 11.0399386,13.7761424 11.0399386,13.5 C11.0399386,13.4872031 11.0404299,13.4744109 11.0414114,13.4616518 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z" fill="#000000"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New customer is registered </div>
																			   <div class="kt-notification__item-time"> 3 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <rect fill="#000000" opacity="0.3" x="2" y="9" width="20" height="13" rx="2"></rect>
																					   <rect fill="#000000" opacity="0.3" x="5" y="5" width="14" height="2" rx="0.5"></rect>
																					   <rect fill="#000000" opacity="0.3" x="7" y="1" width="10" height="2" rx="0.5"></rect>
																					   <path d="M10.8333333,20 C9.82081129,20 9,19.3159906 9,18.4722222 C9,17.6284539 9.82081129,16.9444444 10.8333333,16.9444444 C11.0476105,16.9444444 11.2533018,16.9750785 11.4444444,17.0313779 L11.4444444,12.7916011 C11.4444444,12.4782408 11.6398662,12.2012404 11.9268804,12.1077729 L15.4407693,11.0331119 C15.8834716,10.8889438 16.3333333,11.2336005 16.3333333,11.7169402 L16.3333333,12.7916011 C16.3333333,13.1498215 15.9979332,13.3786009 15.7222222,13.4444444 C15.3255297,13.53918 14.3070112,13.7428837 12.6666667,14.0555556 L12.6666667,18.5035214 C12.6666667,18.5583862 12.6622174,18.6091837 12.6535404,18.6559869 C12.5446237,19.4131089 11.771224,20 10.8333333,20 Z" fill="#000000"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> Application has been approved </div>
																			   <div class="kt-notification__item-time"> 3 hrs ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--warning">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect opacity="0.200000003" x="0" y="0" width="24" height="24"></rect>
																					   <path d="M4.5,7 L9.5,7 C10.3284271,7 11,7.67157288 11,8.5 C11,9.32842712 10.3284271,10 9.5,10 L4.5,10 C3.67157288,10 3,9.32842712 3,8.5 C3,7.67157288 3.67157288,7 4.5,7 Z M13.5,15 L18.5,15 C19.3284271,15 20,15.6715729 20,16.5 C20,17.3284271 19.3284271,18 18.5,18 L13.5,18 C12.6715729,18 12,17.3284271 12,16.5 C12,15.6715729 12.6715729,15 13.5,15 Z" fill="#000000" opacity="0.3"></path>
																					   <path d="M17,11 C15.3431458,11 14,9.65685425 14,8 C14,6.34314575 15.3431458,5 17,5 C18.6568542,5 20,6.34314575 20,8 C20,9.65685425 18.6568542,11 17,11 Z M6,19 C4.34314575,19 3,17.6568542 3,16 C3,14.3431458 4.34314575,13 6,13 C7.65685425,13 9,14.3431458 9,16 C9,17.6568542 7.65685425,19 6,19 Z" fill="#000000"></path>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New customer comment recieved </div>
																			   <div class="kt-notification__item-time"> 2 days ago </div>
																		   </div>
																	   </a>
																	   <a href="#" class="kt-notification__item">
																		   <div class="kt-notification__item-icon">
																			   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--danger">
																				   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					   <rect x="0" y="0" width="24" height="24"></rect>
																					   <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#000000"></path>
																					   <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519) " x="16.3255682" y="2.94551858" width="3" height="18" rx="1"></rect>
																				   </g>
																			   </svg>
																		   </div>
																		   <div class="kt-notification__item-details">
																			   <div class="kt-notification__item-title"> New customer is registered </div>
																			   <div class="kt-notification__item-time"> 3 days ago </div>
																		   </div>
																	   </a>
																   </div>
															   </div>
														   </div>
													   </div>
												   </div>
												   <!--end:: Widgets/Notifcations -->
											   </div>
										   </div>
										   <div class="row">
											   <div class="col-xl-12">
												   <!--begin:: Widgets/Last Updates-->
												   <div class="kt-portlet kt-portlet--height-fluid">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">
														   Latest Updates
													   </h3> </div>
														   <div class="kt-portlet__head-toolbar today"> <a href="#" class="btn btn-label-brand btn-bold btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
														   Today
													   </a>
															   <div class="dropdown-menu dropdown-menu-fit dropdown-menu-md dropdown-menu-right dropdown-menu-anim-today" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(68px, 45px, 0px);">
																   <!--begin::Nav-->
																   <ul class="kt-nav">
																	   <li class="kt-nav__head"> Export Options <span data-toggle="kt-tooltip" data-placement="right" title="" data-original-title="Click to learn more...">
																	   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon kt-svg-icon--brand kt-svg-icon--md1">
																		   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																			   <rect x="0" y="0" width="24" height="24"></rect>
																			   <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"></circle>
																			   <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"></rect>
																			   <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"></rect>
																		   </g>
																	   </svg> </span> </li>
																	   <li class="kt-nav__separator"></li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-drop"></i> <span class="kt-nav__link-text">Activity</span> </a>
																	   </li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-calendar-8"></i> <span class="kt-nav__link-text">FAQ</span> </a>
																	   </li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-telegram-logo"></i> <span class="kt-nav__link-text">Settings</span> </a>
																	   </li>
																	   <li class="kt-nav__item">
																		   <a href="#" class="kt-nav__link"> <i class="kt-nav__link-icon flaticon2-new-email"></i> <span class="kt-nav__link-text">Support</span> <span class="kt-nav__link-badge">
																		   <span class="kt-badge kt-badge--success kt-badge--rounded">5</span> </span>
																		   </a>
																	   </li>
																	   <li class="kt-nav__separator"></li>
																	   <li class="kt-nav__foot"> <a class="btn btn-label-danger btn-bold btn-sm" href="#">Upgrade plan</a> <a class="btn btn-clean btn-bold btn-sm" href="#" data-toggle="kt-tooltip" data-placement="right" title="" data-original-title="Click to learn more...">Learn more</a> </li>
																   </ul>
																   <!--end::Nav-->
															   </div>
														   </div>
													   </div>
													   <div class="kt-portlet__body">
														   <!--begin::widget 12-->
														   <div class="kt-widget4">
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon-pie-chart-1 kt-font-info"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   Metronic v6 has been arrived!
														   </a> <span class="kt-widget4__number kt-font-info">+500</span> </div>
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon-safe-shield-protection  kt-font-success"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   Metronic community meet-up 2019 in Rome.
														   </a> <span class="kt-widget4__number kt-font-success">+1260</span> </div>
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon2-line-chart kt-font-danger"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   Metronic Angular 8 version will be landing soon...
														   </a> <span class="kt-widget4__number kt-font-danger">+1080</span> </div>
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon2-pie-chart-1 kt-font-primary"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   ale! Purchase Metronic at 70% off for limited time
														   </a> <span class="kt-widget4__number kt-font-primary">70% Off!</span> </div>
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon2-rocket kt-font-brand"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   Metronic VueJS version is in progress. Stay tuned!
														   </a> <span class="kt-widget4__number kt-font-brand">+134</span> </div>
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon2-notification kt-font-warning"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   Black Friday! Purchase Metronic at ever lowest 90% off for limited time
														   </a> <span class="kt-widget4__number kt-font-warning">70% Off!</span> </div>
															   <div class="kt-widget4__item"> <span class="kt-widget4__icon">
															   <i class="flaticon2-file kt-font-success"></i>
														   </span> <a href="#" class="kt-widget4__title kt-widget4__title--light">
															   Metronic React version is in progress.
														   </a> <span class="kt-widget4__number kt-font-success">+13%</span> </div>
														   </div>
														   <!--end::Widget 12-->
													   </div>
												   </div>
												   <!--end:: Widgets/Last Updates-->
											   </div>
										   </div>
									   </div>
								   </div>
								   <div class="tab-pane" id="kt_user_edit_tab_6" role="tabpanel">
								     <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12 col-lg-12">
												   <div class="kt-portlet">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">Notification Center</h3> 
														   </div>
														   <div class="kt-portlet__head-toolbar">
														   <div class="kt-portlet__head-wrapper">
															   <div class="dropdown dropdown-inline">
																   <button type="button" class="btn btn-label-brand btn-sm btn-icon btn-icon-md">
																		<i class="flaticon2-list-1"></i>
																	</button>
															   </div>
														   </div>
													   </div>
													   </div>
													   <form class="kt-form kt-form--label-right">
														   <div class="kt-portlet__body">
															   <div class="kt-section kt-section--first">
																   <div class="kt-section__body">
																	   <div class="form-group row mt-5 mb-5">
																		   <label class="col-form-label text-primary font-weight-bold">Platform Mandatory Notifications (No Opt-Out)</label>
																		   <div class="row card shadow-sm rounded-lg pt-4 col-lg-12 col-xl-12">
																			   <div class="col-lg-10 col-xl-10 notification_text">You are notified about new messages, pending requests on your account, all new information related to your transactions and data purchases, data source suggestions and more.</div>
																			   <div  id="pad" class="col-lg-2 col-xl-2"><label  class="switch"><input  type="checkbox" checked><span  class="slider round"></span></label></div>
																		   </div>
																	   </div>
																	   <div class="form-group row mt-5 mb-5">
																		   <label class="col-form-label text-primary font-weight-bold">DataPitcher Advice and Recommendations</label>
																		   <div class="row card shadow-sm rounded-lg pt-4 col-lg-12 col-xl-12">
																			   <div class="col-lg-10 col-xl-10 notification_text">Get advice and tips about using and configuring your account on the marketplace.</div>
																			   <div  id="pad" class="col-lg-2 col-xl-2"><label  class="switch"><input  type="checkbox"><span  class="slider round"></span></label></div>
																		   </div>
																	   </div>
				   
																	   <div class="form-group row mt-5 mb-5">
																		   <label class="col-form-label text-primary font-weight-bold">Newsletter</label>
																		   <div class="row card shadow-sm rounded-lg pt-4 col-lg-12 col-xl-12">
																			   <div class="col-lg-10 col-xl-10 notification_text">Receive our latest news, read about trends in the data economy, and discover our recent changes.</div>
																			   <div  id="pad" class="col-lg-2 col-xl-2"><label  class="switch"><input  type="checkbox"><span  class="slider round"></span></label></div>
																		   </div>
																	   </div>
																	   <hr>
																	   <div class="form-group row button">
																		   <button class="btn btn-success offset-lg-5 offset-xl-5">Submit</button>
																	   </div>
																   </div>
															   </div>
														   </div>
													   </form>
													</div>
												</div>
											</div>
										</div>
								   </div>
								   <div class="tab-pane" id="kt_user_edit_tab_7" role="tabpanel">
								   	 <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
										   <div class="row">
											   <div class="col-xl-12 col-lg-12">
												   <div class="kt-portlet">
													   <div class="kt-portlet__head">
														   <div class="kt-portlet__head-label">
															   <h3 class="kt-portlet__head-title">Close and Delete Account</h3> 
														   </div>
														   <div class="kt-portlet__head-toolbar">
														   <div class="kt-portlet__head-wrapper">
															   <div class="dropdown dropdown-inline">
																   <button type="button" class="btn btn-label-brand btn-sm btn-icon btn-icon-md">
																	   <i class="flaticon2-cross"></i>
																   </button>
															   </div>
														   </div>
													   </div>
													   </div>
													   <form class="kt-form kt-form--label-right">
														   <div class="kt-portlet__body">
															   <div class="kt-section kt-section--first">
																   <div class="kt-section__body">
																	   <div class="row mt-4">
																		   <div class="col-lg-12 col-xl-12 close_account_info"> Before you can mark your account for closure, you must review and select the following check boxes to acknowledge that you've reviewed each of the most common account closure effects. </div>
																	   </div>
																	   <div class="form-group row mt-5 pl-2">
																		   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check">I understand that by clicking this checkbox, I am closing my DataPitcher account. The closure of my DataPitcher account serves as notice to DataPitcher that I wish to terminate the DataPitcher Customer Agreement or any other agreement with DataPitcher that governs my DataPitcher account, solely with respect to that DataPitcher account. <span class="mt-1"></span></label>
																	   </div>
																	   <div class="form-group row mt-5 pl-2">
																		   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check">I understand that after the Post-Closure Period I will no longer be able to reopen my closed account. <span class="mt-1"></span></label>
																	   </div>
																	   <div class="form-group row mt-5 pl-2">
																		   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check"> I understand that after the Post-Closure Period I will no longer be able to access the DataPitcher Console to view past offerings and purchased invoices. <span class="mt-1"></span></label>
																	   </div>
																	   <div class="form-group row mt-5 pl-2">
																		   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check"> I understand that after the Post-Closure Period I will not be able to create a new DataPitcher account with the email address or phone number currently associated with this account.<span class="mt-1"></span></label>
																	   </div>
																	   <div class="form-group row mt-5 pl-2 mb-5">
																		   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check">I understand that my data offerings already published will be retained by DataPitcher as per their agreement with purchaser of that offering.<span class="mt-1"></span></label>
																	   </div>
																	   <hr>
																	   <div class="form-group row button">
																		   <button class="btn btn-danger offset-lg-5 offset-xl-5">Delete Account</button>
																	   </div>
																   </div>
															   </div>
														   </div>
													   </form>
													</div>
												</div>
											</div>
										</div>
								   </div>
								 </div>
								</form>
							   </div>
							  </div>
							</div>
						   </div>
						  <!--End:: App Content-->
						 </div>
					   <!--End::App-->
					   </div>
					   <!-- end:: Content -->
					 </div>
				   </div>
			   </div>
		   </section>
	   </div>
	 </div>
   </div>